// Smart, self-regulating "Promouvoir" (promote) nudge helpers.
// Goal: show the promote banner on at most ONE post (the best-performing recent one),
// let the author dismiss it, and stay quiet for a cooldown so the admin rarely intervenes.

const MUTE_KEY = "yalola.promoteNudge.mutedUntil";

export const isNudgeMuted = () => {
  try {
    return Date.now() < parseInt(localStorage.getItem(MUTE_KEY) || "0", 10);
  } catch {
    return false;
  }
};

export const muteNudgeDays = (days) => {
  try {
    const d = Math.max(1, Number(days) || 7);
    localStorage.setItem(MUTE_KEY, String(Date.now() + d * 86400000));
  } catch {
    /* ignore */
  }
};

const engagement = (p) => (p.reaction_total || 0) + (p.comment_count ?? p.comments_count ?? 0);

// Is a single post eligible for the promote nudge (owner + recent + crossed a threshold)?
export const isPostNudgeEligible = (post, cfg, userId) => {
  cfg = cfg || {};
  if (cfg.enabled === false) return false;
  const isOwner = post.is_owner || (userId && post.author && post.author.id === userId);
  if (!isOwner || post.is_ad || post.is_promoted || post.promoted) return false;
  const minR = cfg.min_reactions ?? 10;
  const minC = cfg.min_comments ?? 5;
  const reactions = post.reaction_total || 0;
  const comments = post.comment_count ?? post.comments_count ?? 0;
  if (!(reactions >= minR || comments >= minC)) return false;
  const recency = cfg.recency_days ?? 14;
  if (recency > 0 && post.created_at) {
    const age = Date.now() - new Date(post.created_at).getTime();
    if (age > recency * 86400000) return false;
  }
  return true;
};

// From a feed list, pick the single best post to nudge (highest engagement).
export const pickTopNudgePostId = (posts, cfg, userId) => {
  if (isNudgeMuted()) return null;
  const eligible = (posts || []).filter((p) => isPostNudgeEligible(p, cfg, userId));
  if (!eligible.length) return null;
  eligible.sort((a, b) => engagement(b) - engagement(a));
  return eligible[0].id;
};
